module.exports = __webpack_public_path__ + "img/quest_icon_0034_target.4d3cbc7b.png";